import { Table as ATable } from 'antd';
import SVGIcon from '../SVGIcon/SVGIcon';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Table = styled(ATable)<any>`
  @media screen and (max-width: 500px) {
    .ant-table-thead > tr {
      display: flex;
      justify-content: space-between;
      th:first-child {
        flex: 1;
      }
    }
    .ant-table-row td:not(:last-child) {
      border-bottom: none;
    }
    .ant-table-tbody > tr:hover,
    .ant-table-tbody > tr > td:hover {
      background-color: white !important;
    }
  }
  .ant-table-thead > tr > th {
    background: white;
    color: rgba(0, 0, 0, 0.54);
  }
  p {
    display: flex;
  }
  .label {
    color: rgba(0, 0, 0, 0.54);
    flex: 1;
  }
`;

export const NoteIcon = styled(SVGIcon)<any>`
  ${({ note }) =>
    note === 'true'
      ? `
    path {
      fill: #2e904e;
    }
  `
      : ``};
`;

export const Label = styled.span`
  color: rgba(0, 0, 0, 0.54);
  min-width: 80pt;
  margin-right: 10pt;
`;

export const ExpandIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 8px;
`;

export const OrderContainer = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  box-shadow: 4px 4px 8px rgba(4, 15, 15, 0.12);
  overflow-x: auto;
`;

export const ItemCell = styled.div<any>`
  padding: 8px 12px;
  background: white;
  height: 60px;
  flex: ${({ flex }) => flex || '1 0 0'};
  flex-basis: ${({ fbasis }) => fbasis};
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
`;

export const OrderItem = styled.div<any>`
  display: flex;
  justify-content: ${({ justify }) => (justify ? justify : 'flex-start')};
  align-items: ${({ align }) => (align ? align : 'center')};
  // border-top: 1px solid #e8e8e8;
  box-sizing: border-box;
  transition: all 0.3s ease;
  background-color: white;
  &.header {
    border: none;
    color: rgba(0, 0, 0, 0.54);
    text-transform: capitalize;
  }
  &:hover:not(.header) ${ItemCell} {
    background-color: #f0f8fb;
  }
  &.header:hover {
    box-shadow: none;
  }
`;

export const StyledLink = styled(Link)`
  color: rgba(0, 0, 0, 0.87);
  &:hover {
    color: #40a9ff;
  }
  display: -webkit-inline-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
`;

export const OrderContainerMobile = styled.div``;

export const OrderItemMobile = styled.div`
  padding: 24px;
  border-bottom: 1px solid #e8e8e8;
`;

export const OrderContainerDesktop = styled.div`
  border: 1px solid #e8e8e8;
  margin: 24px;
`;
export const MoneyRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const MoneyValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #343538;
`;

export const MoneyDiscountValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #43a047;
`;

export const MoneyLabel = styled.span`
  color: rgba(0, 0, 0, 0.54);
`;
